import React, { Component } from 'react';
import './Fields.css';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import withAuthorization  from './withAuthorization';
import AuthService from '../services/auth';
import Api from '../services/api';
import moment from 'moment'
import './SettingsPayments.css';
import Countdown from 'react-countdown-now';

class SettingsPasses extends Component {

  constructor(props) {
    super(props);

    this.state = {
      active: [],
      available: [],
      expired: [],
    };
  }

  componentDidMount(){
    this.refreshMagnetList();
  }

  refreshMagnetList() {
    (new Api()).get('/passes/list', {}, AuthService.getAuthCookie())
      .then(response => {
        this.setState(response);
      })
  }

  activateMagnet(id) {
    (new Api()).post('/passes/activate', {magnetId: id}, AuthService.getAuthCookie())
      .then(response => {
        if(response.success) {
          this.refreshMagnetList();
        }
      })
  }

  render() {
    const { active, available, expired } = this.state;
    return (
      <div className="col col-12 col-md-8">
        <div className="title">
          Active Superior Passes
        </div>
        <div className="payments-list">
          {active.map(payment => {
            return(
              <div key={payment.id} className="row single-payment">
                <div className="col col-12">
                  <div className="name">
                    24 Hours Superior Pass
                  </div>
                </div>
                <div className="col col-6 data">
                  Active since: {moment(payment.expiryDate).subtract(1,'days').format('MMMM DD, YYYY HH:mm')}
                </div>
                <div className="col col-6 data">
                  Time left: <Countdown
                  date={parseInt(moment(payment.expiryDate).format('x'),10)}
                />
                </div>
              </div>
            );
          })}
          {active.length === 0 &&
          <div className={'row'}>
            <div className="col col-12 empty">
              <p>There are no active superior passes tied to your account.</p>
            </div>
          </div>
          }
        </div>
        <div className="title">
          Available Superior Passes
        </div>
        <div className="payments-list">
          {available.map(payment => {
            return(
              <div key={payment.id} className="row single-payment justify-content-between">
                <div className="col col-auto">
                  <div className="name">
                    24 Hours Superior Pass
                  </div>
                </div>
                <div className="col col-auto button-container">
                  <button
                    className="btn submit"
                    onClick={() => {this.activateMagnet(payment.id)}}
                  >
                    Activate Superior Pass
                  </button>
                </div>
              </div>
            );
          })}
          {available.length === 0 &&
          <div className={'row'}>
            <div className="col col-12 empty">
              <p>There are no available superior passes tied to your account.</p>
            </div>
          </div>
          }
        </div>
        <div className="title">
          Expired Superior passes
        </div>
        <div className="payments-list">
          {expired.map(payment => {
            return(
              <div key={payment.id} className="row single-payment">
                <div className="col col-12">
                  <div className="name">
                    24 Hours Superior Pass
                  </div>
                </div>
                <div className="col col-6 data">
                  Date of purchase: {moment(payment.created_at).format('MMMM DD, YYYY')}
                </div>
                <div className="col col-6 data">
                  Duration: 24H
                </div>
              </div>
            );
          })}
          {expired.length === 0 &&
            <div className={'row'}>
              <div className="col col-12 empty">
                <p>There are no expired superior passes tied to your account.</p>
              </div>
            </div>
          }
        </div>
      </div>
    )
  }
}


const mapStateToProps = (state, props) => {
  return({
    ...props,
    ucdUser: state.sessionState.ucdUser,
    authUser: state.sessionState.authUser,
  });};

const authCondition = (authUser) => !!authUser;

export default compose(withAuthorization(authCondition), connect(mapStateToProps))(SettingsPasses);


// WEBPACK FOOTER //
// ./src/components/SettingsPasses.js